import { Helmet } from "react-helmet";
import React, { Component } from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import "../../styles/customers/customerDetails.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from '../../Layout/layout';
import { setLoadingPage, setErrorMessage } from '../../reducers/actions';
import { connect } from 'react-redux';
import { utcToLocal } from "../../utils/dateConvert"

class CustomerDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      timeZoneArr: [],
      lat: -37.8136276,
      lng: 144.9630576,
      address: "Thelangerin Rd, Hay NSW 2711, Australia",
      name: "",
      description: "",
      speedException: '',
      status: 1,
      statusString: "",
      timeZone: "",
      id: "",
      updated: "",
      created: "",
      tempA: '',
      tempB: '',
    };
  }
  async componentDidMount() {
    console.log("props", this.props)
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(`${apiHost}/api/Customer/UpdateCustomer/${this.props.match.params.id}`, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
      });
      if (response.status == "200") {
        this.setData(response.data)
        this.setState({ speedException: response.data.speedExceptionDurationLimit });
      }

      this.props.setLoadingPageAction(false);

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setData = (data) => {
    const { name, latitude, longitude, description, dbUpdated, dbCreated, status, timeZoneCity, id, tempA, tempB, address } = data;
    this.setState({ name, address, description, tempA: tempA, tempB: tempB, lat: latitude, lng: longitude, timezone: timeZoneCity, statusString: status, id, updated: dbUpdated, created: dbCreated })
  }

  handleOk = () => {
    this.props.history.push("/customers");
  }

  handleEdit = () => {
    this.props.history.push(`/editCustomer/${this.state.id}`);
  }

  render() {
    const { lat, lng, address, name, description, timezone, statusString, id, created, updated } = this.state;

    return (
      <React.Fragment>
        <Layout>

          <Helmet>
            <title>Customer Details </title>

          </Helmet>
          <div className="customerDetailWrapper">

            <h1>Customer Details</h1>
            <Form>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Name</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{name}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Description</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{description}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Status</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{statusString}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Temp A Threshold</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{this.state.tempA}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Temp B Threshold</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{this.state.tempB}</p>
                </Col>
              </Row>   <Row>
                <Col sm="2">
                  <p className="detailsLabel">Speed Exception Duration Limit</p>
                  <div> <p className="detailsLabel" style={{ fontSize: '10px', position: 'relative', top: '-5px' }}>(In Seconds ) </p></div>

                </Col>
                <Col sm="10">
                  <p className="detailsValue">{this.state.speedException}</p>
                </Col>
              </Row>

              <Row>
                <Col sm="2">
                  <p className="detailsLabel">TimeZone</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{timezone}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Address</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">Position (<span>{lat}, {lng})</span>
                  </p><br />
                  <p>{address}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">ID</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{id}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Created</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{utcToLocal(created)}</p>
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <p className="detailsLabel">Updated</p>
                </Col>
                <Col sm="10">
                  <p className="detailsValue">{utcToLocal(updated)}</p>
                </Col>
              </Row><br />
              <Row>
                <Col sm="2">

                </Col>
                <Col sm="10">

                  <Button variant="light" onClick={this.handleOk}>Ok</Button>&nbsp;&nbsp;
                  <Button variant="primary" onClick={this.handleEdit}>Edit</Button>
                </Col>
              </Row>
            </Form>
            <br />
            <br />
          </div>
        </Layout>
      </React.Fragment>

    );
  }

}

const mapStateToProps = (state) => ({

  loading: state.loading

})
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage


}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetail);
